import { render, staticRenderFns } from "./DistributionOfDirectCostsChart.vue?vue&type=template&id=60659855"
import script from "./DistributionOfDirectCostsChart.vue?vue&type=script&lang=js"
export * from "./DistributionOfDirectCostsChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports